import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionEnfermedadCatastroficaDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionEnfermedadCatastroficaService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getEstadoRevisionEnfermedadCatastroficaService(): Observable<BodyListResponse<EstadoRevisionEnfermedadCatastroficaDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionEnfermedadCatastroficaDTO>>(API_URL + '/api/v1/estadoRevisionEnfermedadCatastrofica/todos');
  }

  guardarEstadoRevisionEnfermedadCatastroficaService(estadoRevisionEnfermedadCatastroficaDTO: EstadoRevisionEnfermedadCatastroficaDTO): Observable<EstadoRevisionEnfermedadCatastroficaDTO> {
    return this.http.post<EstadoRevisionEnfermedadCatastroficaDTO>(API_URL + '/api/v1/estadoRevisionEnfermedadCatastrofica', estadoRevisionEnfermedadCatastroficaDTO);
  }

  getEstadoRevisionEnfermedadCatastroficaPorCodigoEstadoRevisionEnfermedadCatastroficaService(codigoEstadoRevisionEnfermedadCatastrofica: string): Observable<BodyResponse<EstadoRevisionEnfermedadCatastroficaDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionEnfermedadCatastroficaDTO>>(API_URL + '/api/v1/estadoRevisionEnfermedadCatastrofica/' + codigoEstadoRevisionEnfermedadCatastrofica);
  }

   getEstadoRevisionEnfermedadCatastroficaPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionEnfermedadCatastroficaDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionEnfermedadCatastroficaDTO>>(API_URL + '/api/v1/estadoRevisionEnfermedadCatastrofica/persona/' + codigoPersona);
  }

}
